export default __webpack_public_path__ + "static/media/kings_thumb.cb4b9ce1.jpeg";